export enum StatusEmissao {
  Emitido = "EMITIDO",
  Processando = "PROCESSANDO",
  Falha = "FALHA",
  DadosInconsistentes = "DADOS_INCONSISTENTES",
  ExercicioIndisponivel = "EXERCICIO_INDISPONIVEL",
}

export enum StatusEmissaoExibir {
  EMITIDO = "Emitido",
  PROCESSANDO = "Processando",
  FALHA = "Falha",
  DADOS_INCONSISTENTES = "Dados inconsistentes",
  EXERCICIO_INDISPONIVEL = "Exercicio indisponível",
}
